export const environment = {
    production: false,
    // url: 'http://localhost:3001/api'
    // url: 'http://localhost:3000/api/'
    // url: 'https://crypbooks.com/api',
    // imguri: 'https://crypbooks.com/',
    url: 'https://dev.crypbooks.com/api',
    imguri: 'https://dev.crypbooks.com/',
};
